import logo_header_desktop from '../../assets/imgs/logo_header_desktop.svg'
import { PAGE_URLS } from '../../constants/hrefLinks'
import './style.scss'
// import { useAppSelector } from '../../redux/hooks';

function Footer() {
	// const useMobileLayout = useAppSelector(state => state.resize.useMobileLayout)

	return (
		<div className="footer-wrap">
			<div className='footer-logo-wrap'>
				<img
					src={logo_header_desktop}
					className="footer-logo"
					alt="Skivio logo"
				/>
			</div>
			<div className='footer-columns-wrap'>
				<span className='footer-column-header'>Support</span>
				{/* <a href='/' className='footer-column-item'>Help Centre</a> */}
				<a href={PAGE_URLS.FAQ} className='footer-column-item'>FAQs</a>
				<a href={PAGE_URLS.CONTACT_US} className='footer-column-item'>Contact Us</a>
				<a href={PAGE_URLS.TERMS_AND_CONDITIONS} className='footer-column-item'>Terms And Conditions</a>
				<a href={PAGE_URLS.TERMS_AND_CONDITIONS} className='footer-column-item'>Cancellation Policy</a>
				<a href={PAGE_URLS.PRIVACY} className='footer-column-item'>Privacy</a>
			</div>
			<div className='footer-columns-wrap'>
				<span className='footer-column-header'>Instructor</span>
				<a href={PAGE_URLS.SIGN_UP_INSTRUCTOR} className='footer-column-item'>Become an Instructor</a>
				<a href={PAGE_URLS.DASHBOARD_CUSTOMER} className='footer-column-item'>Instructor Dashboard</a>
				{/* <a href='/' className='footer-column-item'>Instructor FAQs</a> */}
				<a href={PAGE_URLS.CONTACT_US} className='footer-column-item'>Instructor Support</a>
				{/* <a href='/' className='footer-column-item'>Payment & Earnings</a> */}
				{/* <a href='/' className='footer-column-item'>Community Guidelines</a> */}
			</div>
			<div className='footer-columns-wrap'>
				<span className='footer-column-header'>Stay Connected</span>
				{/* <a href='/' className='footer-column-item'>Blog</a> */}
				<a href={PAGE_URLS.CONTACT_US} className='footer-column-item'>Contact Details</a>
			</div>
		</div>
	)
}

export default Footer